import React, { useEffect, useState } from 'react';

const Api = require('./Config');

export default (props) => {
  const [pendingList, setPendingList] = useState([]);

  useEffect(() => {
    Api.getPendingJourneys().then(setPendingList);
  }, []);

  return (
    <div>
      <div className="container" />
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Patient</th>
            <th>Journey</th>
            <th>T Code</th>
            <th>Created Date</th>
          </tr>
        </thead>
        <tbody>
          {pendingList.map((row, index) => (
            <tr>
              <td>{index + 1}</td>
              <td>{row.patient_ref}</td>
              <td>{row.journey_name}</td>
              <td>{row.t_code}</td>
              <td>{Api.getDateFormat(row.journey_start_date, false)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
